import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Home/HomeView.vue'
import AccountView from '@/views/Settings/Account.vue'
import OrganizationLayout from '@/views/Settings/OrganizationLayout.vue'
import OrganizationView from '@/views/Settings/Organization.vue'
import Members from '@/views/Settings/Members.vue'

const router = createRouter({
    history: createWebHistory(''),
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/campaign-manager/list/active'
        },
        {
            path: '/news',
            name: 'news',
            component: HomeView,
            meta: {
                pageName: 'Home',
                breadcrumbs: [
                    {
                        name: 'Home',
                        routeName: 'home'
                    },
                    {
                        name: 'News',
                        routeName: 'news'
                    }
                ]
            }
        },
        {
            path: '/settings/account',
            name: 'accountSettings',
            component: AccountView,
            meta: {
                pageName: 'Account settings',
                breadcrumbs: [
                    {
                        name: 'Settings',
                        routeName: 'settings'
                    },
                    {
                        name: 'Account settings',
                        routeName: 'accountSettings'
                    }
                ]
            }
        },
        {
            path: '/settings/organization',
            component: OrganizationLayout,
            children: [
                {
                    path: '',
                    name: 'organizationSettings',
                    component: OrganizationView,
                    meta: {
                        pageName: 'Organization',
                        breadcrumbs: [
                            {
                                name: 'Settings',
                                routeName: 'setings'
                            },
                            {
                                name: 'Organization',
                                routeName: 'organizationSettings'
                            }
                        ]
                    }
                },
                {
                    path: 'members',
                    name: 'organizationSettingsMembers',
                    component: Members,
                    meta: {
                        pageName: 'Members',
                        breadcrumbs: [
                            {
                                name: 'Settings',
                                routeName: 'setings'
                            },
                            {
                                name: 'Organization',
                                routeName: 'organizationSettings'
                            },
                            {
                                name: 'Members',
                                routeName: 'organizationSettingsMembers'
                            }
                        ]
                    }
                }
            ]
        }
    ]
})

export default router
